import { useTranslation } from 'react-i18next'
import { Card } from '../ui/card'
import { Badge } from '../ui/badge'
import { DynamicIcon, type IconName } from 'lucide-react/dynamic'
import { Lock } from 'lucide-react'

export interface Template {
  id: string
  name: string
  description: string
  category: string
  icon: string
  screenshot_url: string | null
}

interface TemplateCardProps {
  template: Template
  onClick: (template: Template) => void
  locked?: boolean
}

export function TemplateCard({ template, onClick, locked }: TemplateCardProps) {
  const { t } = useTranslation('projects')

  return (
    <Card
      className="cursor-pointer group relative overflow-hidden py-0"
      onClick={() => onClick(template)}
    >
      <div className="relative h-52 bg-gradient-to-br from-muted/50 to-muted flex items-center justify-center overflow-hidden">
        {template.category === 'business' && (
          <Badge
            variant="outline"
            className="absolute top-2 left-2 z-10 bg-violet-600/90 text-white border-violet-600 text-xs gap-1"
          >
            {locked && <Lock className="h-3 w-3" />}
            {t('templateBrowser.proBadge')}
          </Badge>
        )}
        {template.screenshot_url ? (
          <img
            src={template.screenshot_url}
            alt={`${template.name} Preview`}
            className="absolute inset-0 w-full h-full object-cover object-top"
            loading="lazy"
          />
        ) : (
          <DynamicIcon name={template.icon as IconName} className="h-12 w-12 text-muted-foreground/50 group-hover:scale-110 transition-transform" />
        )}
        {/* Title overlay at bottom */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent p-3">
          <h3 className="font-semibold text-white drop-shadow-md">{template.name}</h3>
          <p className="text-xs text-white/90 line-clamp-1 drop-shadow-sm">{template.description}</p>
        </div>
      </div>
    </Card>
  )
}
